/* ui/game/Scoreboard.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "svelte/internal";

import { scoresStore } from "../store";
import { playerOneStore, playerTwoStore } from "../../stores/player_store";

function add_css() {
	var style = element("style");
	style.id = "svelte-12bftyx-style";
	style.textContent = ".oneScore.svelte-12bftyx{color:#e80000}.twoScore.svelte-12bftyx{color:#00838f}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let br0;
	let t0;
	let label0;
	let t1_value = /*$playerOneStore*/ ctx[0].displayName + "";
	let t1;
	let t2;
	let t3;
	let data0;
	let t4_value = /*$scoresStore*/ ctx[1][0] + "";
	let t4;
	let t5;
	let br1;
	let t6;
	let label1;
	let t7_value = /*$playerTwoStore*/ ctx[2].displayName + "";
	let t7;
	let t8;
	let t9;
	let data1;
	let t10_value = /*$scoresStore*/ ctx[1][1] + "";
	let t10;

	return {
		c() {
			br0 = element("br");
			t0 = space();
			label0 = element("label");
			t1 = text(t1_value);
			t2 = text(":");
			t3 = space();
			data0 = element("data");
			t4 = text(t4_value);
			t5 = space();
			br1 = element("br");
			t6 = space();
			label1 = element("label");
			t7 = text(t7_value);
			t8 = text(":");
			t9 = space();
			data1 = element("data");
			t10 = text(t10_value);
			attr(label0, "class", "oneScore svelte-12bftyx");
			attr(label1, "class", "twoScore svelte-12bftyx");
		},
		m(target, anchor) {
			insert(target, br0, anchor);
			insert(target, t0, anchor);
			insert(target, label0, anchor);
			append(label0, t1);
			append(label0, t2);
			insert(target, t3, anchor);
			insert(target, data0, anchor);
			append(data0, t4);
			insert(target, t5, anchor);
			insert(target, br1, anchor);
			insert(target, t6, anchor);
			insert(target, label1, anchor);
			append(label1, t7);
			append(label1, t8);
			insert(target, t9, anchor);
			insert(target, data1, anchor);
			append(data1, t10);
		},
		p(ctx, [dirty]) {
			if (dirty & /*$playerOneStore*/ 1 && t1_value !== (t1_value = /*$playerOneStore*/ ctx[0].displayName + "")) set_data(t1, t1_value);
			if (dirty & /*$scoresStore*/ 2 && t4_value !== (t4_value = /*$scoresStore*/ ctx[1][0] + "")) set_data(t4, t4_value);
			if (dirty & /*$playerTwoStore*/ 4 && t7_value !== (t7_value = /*$playerTwoStore*/ ctx[2].displayName + "")) set_data(t7, t7_value);
			if (dirty & /*$scoresStore*/ 2 && t10_value !== (t10_value = /*$scoresStore*/ ctx[1][1] + "")) set_data(t10, t10_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(br0);
			if (detaching) detach(t0);
			if (detaching) detach(label0);
			if (detaching) detach(t3);
			if (detaching) detach(data0);
			if (detaching) detach(t5);
			if (detaching) detach(br1);
			if (detaching) detach(t6);
			if (detaching) detach(label1);
			if (detaching) detach(t9);
			if (detaching) detach(data1);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $playerOneStore;
	let $scoresStore;
	let $playerTwoStore;
	component_subscribe($$self, playerOneStore, $$value => $$invalidate(0, $playerOneStore = $$value));
	component_subscribe($$self, scoresStore, $$value => $$invalidate(1, $scoresStore = $$value));
	component_subscribe($$self, playerTwoStore, $$value => $$invalidate(2, $playerTwoStore = $$value));
	return [$playerOneStore, $scoresStore, $playerTwoStore];
}

class Scoreboard extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-12bftyx-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Scoreboard;